import type { Sessao } from '@/auth/session'

/** Where the guard stashes the route the user actually asked for (AC-3). */
export interface EstadoDeRedirecionamento {
  de?: string
}

/**
 * Where a user lands when they reach `/login` directly, with no stashed destination.
 *
 * Their first client rather than a hard-coded tenant, because a Cliente holds exactly
 * one and it is not necessarily the stub's default — landing them on a client they
 * cannot reach would be a 403 as a welcome screen.
 *
 * ⚠️ Story 0.5 owns this properly: last tenant persisted across the session, plus the
 * scope guard that rejects an `idCliente` outside `{clientes}`. This is the honest
 * minimum until then, derived from the session and inventing nothing.
 */
export function destinoPadrao(sessao: Sessao): string {
  const primeiro = sessao.clientes[0]
  return primeiro ? `/cliente/${primeiro}/finops` : '/'
}
